import React, { useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import UserRepository from "../../Repository/UserRepository";
import { toast } from "react-toastify";
import S3FileUpload from "react-s3/lib/ReactS3";

const config = {
  bucketName: "ats-bucket-hardware",
  dirName: "photos",
  error: "",
  region: "us-east-1",
  accessKeyId: "AKIA44SH2DQ6NF3SXOFL",
  secretAccessKey: "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",
  headers: {
    "Access-Conrol-Allow-Origin": "*",
  },
};

function UpdateImg({ user, onClose, onSuccess }) {
  const [state, setState] = useState({
    image: "",
  });

  const handleInput = (e) => {
    const value = e.target.files[0];
    const name = e.target.name;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUpdate = async () => {
    if (state.image == "") {
      toast.configure();
      toast.info("Select Image");
      return;
    }
    onClose();
    let base_url = await getBase64(state.image);
    localStorage.setItem("base_url", base_url);

    let Url = await S3FileUpload.uploadFile(state.image, config);

    let { data } = await UserRepository.usersModel({
      request: {
        method: "updateUser",
        data: {
          _id: user._id,
          user: {
            ...user,
            imgURL: Url.location,
            base_url: base_url,
          },
        },
      },
    });
    onSuccess();
  };

  return (
    <Stack gap={2}>
      <Typography variant="h6" sx={{ color: "#4EAF51" }}>
        Change Your Profile Image
      </Typography>
      <Stack direction="row" justifyContent="space-evenly">
        <input
          name="image"
          type="file"
          multiple
          required
          onChange={handleInput}
        />
        <Button
          sx={{ width: "50%" }}
          variant="contained"
          onClick={handleUpdate}
        >
          Save
        </Button>
      </Stack>
    </Stack>
  );
}

export default UpdateImg;
